import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import 'antd/dist/reset.css';

const AppHeader = ({ loggedInUser, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const navItems = [
    { path: '/', name: '首页' },
    { path: '/archive', name: '归档' },
    { path: '/write', name: '写文章' },
    { path: '/my', name: '我的' },
  ];

  // 登出操作
  const handleLogoutClick = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <div style={{ 
      backgroundColor: '#1f2937', 
      padding: '0 20px', 
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'space-between', // 新增：左右布局
      gap: '20px',
      height: '60px'
    }}>
      {/* 左侧导航项 */}
      <div style={{ display: 'flex', gap: '20px' }}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            style={{
              color: 'white',
              textDecoration: 'none',
              fontSize: '16px',
              backgroundColor: currentPath === item.path ? '#2563eb' : 'transparent',
              padding: '8px 16px',
              borderRadius: '4px'
            }}
          >
            {item.name}
          </Link>
        ))}
      </div>

      {/* 右侧登录状态/操作 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {!loggedInUser ? (
          // 未登录：显示登录按钮
          <Button 
            type="primary" 
            size="middle"
            onClick={() => navigate('/login')}
            style={{ backgroundColor: '#2563eb', borderColor: '#2563eb' }}
          >
            登录
          </Button>
        ) : (
          // 已登录：显示用户名 + 登出按钮
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ color: 'white', fontSize: '14px' }}>
              欢迎，{loggedInUser.username}
            </span>
            <Button 
              type="default" 
              size="middle"
              onClick={handleLogoutClick}
              style={{ color: 'white', borderColor: '#4b5563', backgroundColor: '#374151' }}
            >
              登出
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppHeader;

